module.exports = __webpack_public_path__ + "assets/img/news (16).b7adb426.png";